import { forwardRef, type SVGProps } from 'react';

export type FinderProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Finder = forwardRef<SVGSVGElement, FinderProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <g opacity="0.87" stroke="currentColor">
      <rect height="12" rx="0.5" width="13" x="1.5" y="2" />
      <rect fill="currentColor" height="1.5" rx="0.25" strokeWidth="0.5" width="0.5" x="4.75" y="4.75" />
      <rect fill="currentColor" height="1.5" rx="0.25" strokeWidth="0.5" width="0.5" x="10.75" y="4.75" />
      <path d="M8 2L7 9H9V13.5" />
      <path d="M4 10C4 10 5.5 11.5 8 11.5C10.5 11.5 12 10 12 10" strokeLinecap="round" />
    </g>
  </svg>
));
Finder.displayName = 'Finder';
